module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-regular.eb6120565d177274c59c.woff";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-regular.woff
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-regular.woff
// module chunks = styles